import PropTypes from "prop-types";
import { useState } from "react";

const PinInput = ({
  name,
  title,
  value,
  error,
  handleChange,
  placeholder,
  className,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className=" text-start">
      {title && (
        <label className="d-flex align-items-center fs-12 mb-1 form-label">
          <span className="required">{title}</span>
        </label>
      )}

      <div className="position-relative">
        <span className="position-absolute top-50 start-0 translate-middle-y ps-3">
          <i className="bi bi-key-fill text-muted"></i>
        </span>
        <input
          type={visible ? "tel" : "password"}
          maxLength={4}
          pattern="[0-9]*"
          inputMode="numeric"
          className={
            className ? className : "form-control form-control-solid ps-5 pe-5"
          }
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            const input = e.target.value.replace(/\D/g, "");
            handleChange({ target: { name, value: input } });
          }}
        />

        {/* Toggle visibility icon */}
        <span
          className="position-absolute top-50 end-0 translate-middle-y pe-3"
          onClick={() => setVisible(!visible)}
          style={{ cursor: "pointer" }}
        >
          {visible ? (
            <i className="bi bi-eye-fill text-muted"></i>
          ) : (
            <i className="bi bi-eye-slash-fill text-muted"></i>
          )}
        </span>
      </div>
      {/* {error && */}
       <span className="fs-10 text-danger ps-3 ">{error}</span>
       {/* } */}
    </div>
  );
};

PinInput.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

export default PinInput;
